import React, { useEffect, useState, useContext, useRef } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { TextField, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import {setPlayerBidResource } from "../../services/transfers.service";
import { SiteVarsContext } from "../../contexts/sitevars-context";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PremPlayersContext from '../../contexts/premplayers-context';
import { useSiteVarsFunctions } from "../../hooks/use-site-vars-functions";
import UserPendingTransactionsContext from '../../contexts/user-pending-transactions-context';
import { PlayerImage } from "../player/player-image";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialogActions-root': {
    //padding: theme.spacing(1),
  },
}));

export default function MakeBidDialogue({open, playerId, handleCloseMakeBidDialogue, setNavValue}) {
  const {getPlayerPositionById, getTeamById } = useSiteVarsFunctions();
  const { user } = useAuth0();
  const { addUserPendingTransaction } = useContext(UserPendingTransactionsContext);
  const bidAmountRef = useRef();
  const [bidError, setBidError] = useState(false);
  const {premPlayersData, isLoadingPremPlayersData} =  useContext(PremPlayersContext);
  const playerData = premPlayersData.find(player => player.playerId === playerId);

  const handleClose = () => {
    handleCloseMakeBidDialogue(false);
  };
  
  const handleMakeBid = async () => {
    const clubId = user['https://tlog-online.co.uk/club_id'];
    const bidAmount = bidAmountRef.current.value;
    //bid amount needs to be 2.50 or greater
    if(Number(bidAmount) < 2.5) {
      setBidError(true);
      return;
    } else {
      setBidError(false);
    }
    const bidPlaceResponse = await setPlayerBidResource(clubId, playerData.playerId, bidAmount, playerData.lastName, getPlayerPositionById(playerData.positionId).name, getTeamById(playerData.teamId).name);
    
    /**
     * Check place bid is successful
     * Set the player as loaned out in the UserPendingTransactionsContext
    */
    if(bidPlaceResponse.data.success) {
      addUserPendingTransaction(bidPlaceResponse.data.bid);
    }
    
    handleClose();
    
    if(bidPlaceResponse.data.success) {
      setNavValue(1);
    }
  };


  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 , lineHeight: 0.8}} id="customized-dialog-title">
          Make Bid
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Grid container>
          <Grid item xs={4} sx={{p:1}}>
              <PlayerImage player={playerData} style={{ width: '65px', height: '83px' }} />
          </Grid>
          <Grid item xs={8}>
          <span style={{fontWeight: 'bold'}}>{playerData.firstName} {playerData.lastName}</span><br />
          {getPlayerPositionById(playerData.positionId).name} - {getTeamById(playerData.teamId).name}<br />
          Cost: {playerData.originalCost}<br />
          Points: {playerData.totalPoints}<br />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={8} sx={{p:1}}>
            <TextField id="standard-basic" label="Bid Amount" error={bidError} helperText={bidError ? "2.50 minimum" : ""} size="6" variant="standard" placeholder="2.50" inputRef={bidAmountRef} />
          </Grid>
          <Grid item xs={4} >
            <Button style={{ marginTop: '20px' }} variant="contained" color="primary" onClick={() => handleMakeBid()}>Make Bid</Button>
          </Grid>
        </Grid>
      </BootstrapDialog>
    </div>
  );
}